import React from 'react';
import {Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {Box} from "@mui/system";

export interface ITextStep {
    stepKey: string;
}

const TextStep = (props: ITextStep) => {
    const {t} = useTranslation(['network']);
    const width = window.innerWidth * 80 / 100;

    return (
        <>
            <Typography variant="h6" mb={2}>{t(`digitalSign.step.${props.stepKey}.title`)}</Typography>
            <Box sx={{width: width}}>
                <Typography variant={'body1'}>{t(`digitalSign.step.${props.stepKey}.content`)}</Typography>
            </Box>
        </>
    );
};

export default TextStep;